// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScheduleHistoryTabQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type ScheduleHistoryTabQuery = { __typename?: 'Query', scheduleTask: { __typename?: 'ScheduleTask', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> } };


export const ScheduleHistoryTabDocument = gql`
    query ScheduleHistoryTab($taskId: ID!) {
  scheduleTask(id: $taskId) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useScheduleHistoryTabQuery__
 *
 * To run a query within a React component, call `useScheduleHistoryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleHistoryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleHistoryTabQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useScheduleHistoryTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables> & ({ variables: ScheduleHistoryTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>(ScheduleHistoryTabDocument, options);
      }
export function useScheduleHistoryTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>(ScheduleHistoryTabDocument, options);
        }
// @ts-ignore
export function useScheduleHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>;
export function useScheduleHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleHistoryTabQuery | undefined, ScheduleHistoryTabQueryVariables>;
export function useScheduleHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>(ScheduleHistoryTabDocument, options);
        }
export type ScheduleHistoryTabQueryHookResult = ReturnType<typeof useScheduleHistoryTabQuery>;
export type ScheduleHistoryTabLazyQueryHookResult = ReturnType<typeof useScheduleHistoryTabLazyQuery>;
export type ScheduleHistoryTabSuspenseQueryHookResult = ReturnType<typeof useScheduleHistoryTabSuspenseQuery>;
export type ScheduleHistoryTabQueryResult = Apollo.QueryResult<ScheduleHistoryTabQuery, ScheduleHistoryTabQueryVariables>;